import React, { ComponentProps, Suspense, lazy } from "react";

const LazyMultimodalSearchInputBase = lazy(() =>
  import(
    /* webpackChunkName: "MultimodalSearchInput" */
    "@faire/retailer-visitor-shared/components/TopSearch/MultimodalSearchInput/MultimodalSearchInput"
  ).then((m) => ({ default: m.MultimodalSearchInput }))
);

export const LazyMultimodalSearchInput = (
  props: ComponentProps<typeof LazyMultimodalSearchInputBase>
) => (
  <Suspense fallback={null}>
    <LazyMultimodalSearchInputBase {...props} />
  </Suspense>
);
